import { Button, ButtonTheme } from '@apply/components';
import { CustomPaymentStep } from '../../../../../constants/CustomPaymentStep';

interface NextButtonProps {
    nextDisabled: boolean;
    set_paymentStep: React.Dispatch<React.SetStateAction<CustomPaymentStep>>;
    validationGroupRef: React.RefObject<any>;
}

export const NextButton: React.FC<NextButtonProps> = ({ nextDisabled, set_paymentStep, validationGroupRef }) => {
    const updatePaymentStep = (updatedStep: CustomPaymentStep) => {
        const validationResult = validationGroupRef?.current?.instance?.validate();
        if (!validationResult?.isValid) {
            window.scrollTo(0, 0);
            return;
        }

        window.scrollTo(0, 0);
        set_paymentStep(updatedStep);
    };
    return (
        <>
            <Button
                id='customPaymentNextButton'
                theme={ButtonTheme.Primary}
                type='button'
                disabled={nextDisabled}
                width='160px'
                handleClick={() => updatePaymentStep(CustomPaymentStep.Checkout)}
            >
                Next
            </Button>
        </>
    );
};
